import AxiosClient from "../../../services/axios.services";

class GeneralInfoServices {
  getGeneralInfo = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_datos_generales/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getDescriptor = (params) =>
    AxiosClient.get("/api/app/colaborador_acepta_descriptor/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getGeneralInfoById = (id) =>
    AxiosClient.get(`/api/app/descriptor_perfil_datos_generales/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });

  getPDFDocument = (id, params) =>
    AxiosClient.get(`/api/app/detalle_manual_descriptor/${id}/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  saveGeneralInfo = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_datos_generales/", data, {
      headers: { "Content-Type": "application/json" },
    });

  editGeneralInfo = (id, data) =>
    AxiosClient.put(`/api/app/descriptor_perfil_datos_generales/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  editDescriptor = (id, data) =>
    AxiosClient.put(`/api/app/colaborador_acepta_descriptor/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  deleteGeneralInfo = (id) =>
    AxiosClient.delete(`/api/app/descriptor_perfil_datos_generales/${id}`, {
      headers: { "Content-Type": "aplication/json" },
    });

  mailSendGeneralInfo = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_envio_correo/", data, {
      headers: { "Content-Type": "application/json" },
    });

  getDescriptorManual = (id) =>
    AxiosClient.get(`/api/app/Descargar_Manual_Descriptor/${id}/`, {
      headers: { responseType: "blob" },
    });
}

export default new GeneralInfoServices();
